export default __webpack_public_path__ + "static/media/dongho-2.75fff204.png";